export default __webpack_public_path__ + "static/media/error-bg.e44fdfc6.png";